import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Injectable, Inject } from '@angular/core';
import { appHttpClient } from '@framework';
import { UserRoleModel } from '@models';
import { environment as env } from 'environments/environment';

@Injectable()
export class UserRolesService {
  private get _endpoint() { return env.app_apiURL + '/user/roles' }

  constructor( @Inject('appHttpClient') private _http: appHttpClient) { }
  Find(): Observable<UserRoleModel[]> {
    return this._http.Get(`${this._endpoint}`)
      .map((res: any) => res.json())
      .catch(this.handleError);
  }

  private handleError(error) {
    return Observable.throw(error.json().error || 'Server error');
  }

}
